(function (angular) {
  angular
    .module('repairforms.service.module')
    .service('TealiumService', TealiumService);

  function TealiumService() {
    return {
      trackVirtualPageView: trackVirtualPageView
    };

    function trackVirtualPageView(isConfirmation) {
      if (typeof utag !== 'undefined') {
        window.setTimeout(
          function () {
            var virtualUrl = window.location + (isConfirmation ? "confirmation" : "review");
            var pageName = "Repair Form " + (isConfirmation ? "Confirmation" : "Review");

            utag.view({
              "virtual_url": virtualUrl,
              "page_type": "cms",
              "page_name": pageName
            });
          },
          100
        );

      }
    }

  };

})(angular);
